var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 40,
    viewBox: "0 0 240 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H240C228.954 0 220 8.97768 220 20.0522C220 30.4315 227.865 38.969 237.946 40H2.05408C12.1348 38.9689 20 30.4315 20 20.0522C20 8.97771 11.0457 2.66174e-05 0 2.66174e-05V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M20 20L220 20.0368",
    stroke: "#182B43",
    strokeWidth: 2.82168,
    strokeLinecap: "round",
    strokeDasharray: "0.71 7.05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketMiddle);
export default __webpack_public_path__ + "static/media/ticketMiddle.5dc688b86c2b2ffb37005fc43bf33e11.svg";
export { ForwardRef as ReactComponent };